import {
  type AdminOpenCageStatsResponse,
  AdminOpenCageRateLimitSchema as ContractAdminOpenCageRateLimitSchema,
  AdminOpenCageStatsResponseSchema as ContractAdminOpenCageStatsResponseSchema,
} from '@sweetistics/contracts';

const toRateLimitDate = (candidate: unknown) => {
  if (candidate === undefined) return null;
  if (candidate instanceof Date) return candidate;
  if (typeof candidate === 'string' || typeof candidate === 'number') {
    const parsed = new Date(candidate);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

type RawRateLimitRecord = {
  resetAt?: unknown;
  lastRequestAt?: unknown;
  last429At?: unknown;
};

const normalizeRateLimitDates = (value: unknown) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value !== 'object') {
    return value;
  }

  const input = value as RawRateLimitRecord;
  return {
    ...input,
    resetAt: toRateLimitDate(input.resetAt),
    lastRequestAt: toRateLimitDate(input.lastRequestAt),
    last429At: toRateLimitDate(input.last429At),
  };
};

export const AdminOpenCageRateLimitSchema = ContractAdminOpenCageRateLimitSchema.nullable();

export const AdminOpenCageStatsResponseSchema = ContractAdminOpenCageStatsResponseSchema.transform((payload) =>
  ContractAdminOpenCageStatsResponseSchema.parse({
    ...payload,
    rateLimit: normalizeRateLimitDates(payload.rateLimit),
  })
);

export function serializeAdminOpenCageStatsResponse(payload: AdminOpenCageStatsResponse): AdminOpenCageStatsResponse {
  return AdminOpenCageStatsResponseSchema.parse(payload);
}

export { AdminOpenCageTotalsSchema } from '@sweetistics/contracts';
